import { logError, TAGS } from '@iwLogger/IwDataDogLogger';
import {
    fetchPostFinapiProviderAuthorizationUrl,
    fetchPostFinapiProviderAuthorizationUrlVerification,
    fetchPostTruelayerProviderAuthorizationUrl,
    fetchPostTruelayerProviderAuthorizationUrlVerification
} from '@iwoca/lapi-client/edge';

import { TOnlineBankWithProvider } from './BankSelectionModal.types';

export const getBankAuthUrl = async ({
    bank,
    stateKey
}: {
    bank: TOnlineBankWithProvider;
    stateKey: string;
}) => {
    try {
        if (bank.provider === 'truelayer') {
            return await fetchPostTruelayerProviderAuthorizationUrl({
                stateKey,
                providerId: bank.bank_id
            });
        } else if (bank.provider === 'finapi') {
            return await fetchPostFinapiProviderAuthorizationUrl({
                stateKey,
                providerId: bank.bank_id
            });
        } else {
            throw new Error('Unknown provider');
        }
    } catch (err: unknown) {
        throw new Error(
            `Error fetching auth url: ${err instanceof Error ? err.message : 'Unknown error'}`
        );
    }
};

export const getBankVerificationAuthUrl = async ({
    bank,
    stateKey
}: {
    bank: TOnlineBankWithProvider;
    stateKey: string;
}) => {
    try {
        if (bank.provider === 'truelayer') {
            return await fetchPostTruelayerProviderAuthorizationUrlVerification(
                {
                    stateKey,
                    providerId: bank.bank_id
                }
            );
        } else if (bank.provider === 'finapi') {
            return await fetchPostFinapiProviderAuthorizationUrlVerification({
                stateKey,
                providerId: bank.bank_id
            });
        } else {
            throw new Error('Unknown provider');
        }
    } catch (err: unknown) {
        const errorMessage =
            err instanceof Error ? err.message : 'Unknown error';
        logError(
            `Verification Transactions: error getting auth url: ${errorMessage}`,
            {
                tags: TAGS.DE_BYG
            }
        );
        throw new Error(`Error fetching auth url: ${errorMessage}`);
    }
};
